import plan from '@src/assets/img/lu.png';
export default function () {
    const arr = [plan];
    arr.forEach((url) => {
        const img = new Image();
        img.src = url;
    });
}
